import React from "react";
import { Link } from "react-scroll";
import "../styles/HeroSection.css";

const HeroSection = () => {
  return (
    <section className="hero-section" id="herosection">
      <div className="hero-container">
        <h1 className="hero-title">Welcome to Orifril Lifetech</h1>
        <p className="hero-subtitle">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Smart Solutions For Smarter Healthcare
        </p>
        <br/>
        <Link to="companyOverview" smooth={true} duration={500} offset={-50} className="hero-button">
          See More
        </Link>
      </div>
    </section>
  );
};

export default HeroSection;
